import { CreateClinicPatientType, ClinicPatientType, userType } from "../../DTO";
import { Api } from "../api";
import { extractClinicPatient } from "./shared";

export const CreateClinicPatient = (
    user: userType,
    payload: CreateClinicPatientType,
) => {
    return new Promise<{
        message: string;
        patient: ClinicPatientType;
    }>((resolve, reject) => {
        const api = new Api({
            method: "post",
            path: "clinic/patients",
            header: {
                Authorization: `Bearer ${user.access_token}`,
            },
            body: payload,
            reject422: true,
        });

        return api
            .call()
            .then((data: any) => {
                resolve({
                    message:
                        data?.message || "Clinic patient created successfully.",
                    patient: extractClinicPatient(data?.data ?? data),
                });
            })
            .catch((err: any) => reject(err));
    });
};
